import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import { IconButton, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";

export default () => {
	return (
		<CssColumnGrid columns={4}>
			<Text semiBold text='design="iconOnly" (16)' />
			<Text semiBold text="small (20)" />
			<Text semiBold text="medium (default 26)" />
			<Text semiBold text="custom" />
			<IconButton design="iconOnly" size="large">
				<AllInclusiveIcon />
			</IconButton>
			<IconButton design="secondary" size="small">
				<AllInclusiveIcon />
			</IconButton>
			<IconButton design="secondary" size="large">
				<AllInclusiveIcon />
			</IconButton>
			<IconButton
				customSize={30}
				design="secondary"
				size="large"
			>
				<AllInclusiveIcon style={{ fontSize: 24 }} />
			</IconButton>
		</CssColumnGrid>
	);
};